/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Privacy_H1Inputs */

const en_privacy_h1 = /** @type {(inputs: Privacy_H1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Privacy Policy`)
};

const ko_privacy_h1 = /** @type {(inputs: Privacy_H1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`개인정보처리방침`)
};

const ja_privacy_h1 = /** @type {(inputs: Privacy_H1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`プライバシーポリシー`)
};

/**
* | output |
* | --- |
* | "Privacy Policy" |
*
* @param {Privacy_H1Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const privacy_h1 = /** @type {((inputs?: Privacy_H1Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Privacy_H1Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_privacy_h1(inputs)
	if (locale === "ko") return ko_privacy_h1(inputs)
	return ja_privacy_h1(inputs)
});